import { styled, Button } from '@mui/material';

const SecondaryButton = styled(Button)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#333' : '#e0e0e0',
  color: theme.palette.text.secondary,
  border: '1.5px solid #98773b',
  fontWeight: 500,
  borderRadius: 8,
  padding: '10px 24px',
  fontSize: '1.1em',
  boxShadow: 'none',
  '&:hover': {
    background: theme.palette.mode === 'dark' ? '#444' : '#d5d5d5',
    border: '1.5px solid #98773b',
  },
}));

export default SecondaryButton; 
